import { Injectable } from "@angular/core";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";

@Injectable({
  providedIn: "root",
})
export class GameSettingsService {
  public customer: CustomerModel;

  constructor(
    private userService: UserSessionService,
    private webService: WebservicesService
  ) {
    this.userService.getCustomer().subscribe((customer) => {
      this.customer = customer;
    });
  }

  getSettings() {
    return this.webService.get("customer/get-settings", {
      customer_id: this.customer.customerId,
      session_token: this.userService.getSessionToken(),
    });
  }

  setSettings(settings: any) {
    return this.webService.post("customer/set-settings", {
      customer_id: this.customer.customerId,
      session_token: this.userService.getSessionToken(),
      settings: JSON.stringify(settings),
    });
  }
}
